/**
 * BrandLogo — RC 1.21
 *
 * The NDORFlow logo is an image asset. We NEVER recompose or manipulate
 * the text. Two variants are supported:
 *
 *   variant="full"   → the full provided logo PNG (hex + wordmark + tagline)
 *   variant="symbol" → the standalone hex symbol PNG
 *
 * Rule of thumb (per brand spec):
 *   - Use the full logo only where there is enough horizontal room
 *     (expanded sidebar, login/signup, splash).
 *   - Anywhere it would wrap, shrink, or bleed, use the symbol instead
 *     (favicon, collapsed sidebar, mobile header, loading spinner,
 *     compact cards, quick-action icons).
 */
import React from 'react';

const FULL_SRC   = '/ndorflow-full.png';
const SYMBOL_SRC = '/ndorflow-symbol-512.png';

export default function BrandLogo({
  variant = 'full',
  size,
  className = '',
  testId,
}) {
  if (variant === 'symbol') {
    const px = size || 32;
    return (
      <img
        src={SYMBOL_SRC}
        alt="NDORFlow"
        width={px}
        height={px}
        style={{ width: px, height: px, objectFit: 'contain' }}
        className={className}
        data-testid={testId || 'brand-symbol'}
        draggable={false}
      />
    );
  }

  // Full logo — height-anchored so the baked-in proportions are never broken.
  const h = size || 52;
  return (
    <img
      src={FULL_SRC}
      alt="NDORFlow — Decision Intelligence"
      style={{ height: h, width: 'auto', objectFit: 'contain' }}
      className={className}
      data-testid={testId || 'brand-full'}
      draggable={false}
    />
  );
}
